import { useState } from 'react';
import { createHome } from '../utils/api';

const Onboarding = ({ onCreated }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    setError('');
    try {
      await createHome({ name: name.trim() });
      onCreated();
    } catch (err) {
      setError('Failed to create home. Please try again.');
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🏠</div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>Welcome to Home Maintenance</h1>
        <p style={{ color: 'var(--muted)', marginBottom: '2rem' }}>
          Let's set up your first property. You can add more or invite family members later.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ textAlign: 'left' }}>
            <label className="form-label">Property Name</label>
            <input
              className="form-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. 123 Main St or Lake Cabin"
              autoFocus
              disabled={saving}
            />
          </div>
          {error && <p style={{ color: 'var(--danger)', marginBottom: '1rem', fontSize: '0.875rem' }}>{error}</p>}
          <button className="btn btn-primary" type="submit" disabled={!name.trim() || saving} style={{ width: '100%', marginTop: '0.5rem' }}>
            {saving ? 'Creating…' : 'Create Property'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Onboarding;
